import { useState } from "react";
import clsx from "clsx";
import SmileEmoji from "shared/icons/SmileEmoji";
import SendBold from "shared/icons/SendBold";

interface MessageInputProps {
  className?: string;
  id?: string;
  placeholder?: string;
  onSendMessage: (text: string) => void;
}

export default function MessageInput({
  className,
  id = "message",
  placeholder,
  onSendMessage,
}: MessageInputProps) {
  const [inputText, setInputText] = useState("");

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputText(event.target.value);
  };

  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const text = (event.target as HTMLInputElement).value;
      onSendMessage(text);
      setInputText("");
      setTimeout(() => {
        scrollToBottom();
      }, 500);
    }
  };

  const handleSendClick = () => {
    if (inputText.trim()) {
      onSendMessage(inputText);
      setInputText("");
      setTimeout(() => {
        scrollToBottom();
      }, 500);
    }
  };

  const scrollToBottom = () => {
    const chatContainer = document.getElementById("chat-container");
    if (chatContainer) {
      const lastMessageElement = chatContainer.lastElementChild;
      if (lastMessageElement) {
        lastMessageElement.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      }
    }
  };

  return (
    <div id={`${id}-input`} className={clsx("card", className)}>
      <div className="chat-input-container">
        {/* Emoji Button */}
        <SmileEmoji fontSize={24} />

        {/* Input Field - Should Expand Fully */}
        <div className="inputWrapper">
          <input
            placeholder={placeholder ?? "Search Friends"}
            className="input"
            value={inputText}
            onKeyDown={onKeyDown}
            onChange={handleInputChange}
          />
        </div>

        {/* Right-side Buttons */}
        <div className="rightButtons">
          {/* <IconButton>
            <Camera fontSize={24} />
          </IconButton>
          <IconButton>
            <AttachFile fontSize={24} />
          </IconButton>
          <div className="roundCircle">
            <IconButton>
              <MicroPhone fontSize={24} color={'#ffff'} />
            </IconButton>
          </div> */}
          <div onClick={handleSendClick}>
            <SendBold fontSize={"2.4rem"} />
          </div>
        </div>
      </div>
    </div>
  );
}
